import {Component, EventEmitter, Input, OnDestroy, Output} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';


@Component({
  templateUrl: "./error-dialog.component.html",
  selector: "app-error",
  // styleUrls: ["./error.component.css"]
  providers: [BsModalService]
})


export class ErrorDialogComponent implements OnDestroy{
  // data: { message: string };
  // private errorSub: Subscription;
  //   @Input() title: string = 'Modal with component';
  //   @Input() message: string = 'Message here...';
    @Input() data: any = {};
    @Output() action = new EventEmitter();
    buttonAction = false;


  constructor(public bsModalRef: BsModalRef) {
      this.buttonAction = false;
  }

  ngOnDestroy(){
      if (!this.buttonAction){
        this.action.emit({backdropExit: true});
      }
  }
  clickOk() {
    // console.log("Click ok...");
    this.buttonAction = true;
    this.action.emit(true);
    this.bsModalRef.hide();
  }

  cancel() {
    this.buttonAction = true;
    this.bsModalRef.hide();
    this.action.emit(false);
  }
}
